var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ffimg',{ffimgstatic:_vm.isstatic}]},[_c('img',{staticClass:"noviewer",attrs:{"src":_vm.imgsrc}}),_c('span',{staticClass:"imgzoom"},[_c('img',{attrs:{"src":_vm.imgsrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }